import { createSlice } from "@reduxjs/toolkit";
import {
  getImageLeanList,
  // deleteLean,
  // editLean,
  getLeanById,
  // getLeanList,
  getLeanPage,
  // postLean,
  // getLeanByRegionalId,
} from "../action/leanAction";

const initialState = {
  dataLean: [],
  dataFeedLean: [],
  dataByIdLean: [],
  dataReportByIdLean: '',
  dataLeanByRegionalId: [],
  idLean: "",
  state: "",
  isOpenImageLean: false,
  isOpenDetailLeanPopup: false,
  isOpenForm: false,
  isLoading: false,
  isOpenPDF: false,
};
const leanSlice = createSlice({
  name: "lean",
  initialState,
  reducers: {
    openForm: (state, action) => {
      state.isOpenForm = action.payload.open;
      state.state = action.payload.state;
      if (action.payload.state === "edit") {
        state.dataByIdLean = action.payload.data;
        state.idLean = action.payload.id;
      } else if (action.payload.state === "delete") {
        state.dataByIdLean = action.payload.data;
        state.idLean = action.payload.id;
      }
    },
    openImage: (state, action) => {
      state.isOpenImageLean = action.payload.open;
      state.state = action.payload.state;
      if (action.payload.open === "open") {
        state.dataByIdLean = action.payload.data;
        state.idLean = action.payload.id;
      } else if (action.payload.open === "close") {
        state.dataByIdLean = [];
        state.idLean = "";
      }
    },
    openPDF: (state, action) => {
      state.isOpenPDF = action.payload.open
    },
    openDetail: (state, action) => {
      if(action.payload.open){
        state.isOpenDetailLeanPopup = action.payload.open
        state.dataReportByIdLean = action.payload.data;
      } else {
        state.isOpenDetailLeanPopup = action.payload.open
        state.dataReportByIdLean = '';
      }
    },
  },
  extraReducers: {
    [getLeanPage.pending]: (state) => {
      state.isLoading = true;
    },
    [getLeanPage.fulfilled]: (state, action) => {
      // console.log(action.payload);
      state.dataLean = action.payload.data;
      state.isLoading = false;
    },
    [getLeanPage.rejected]: (state) => {
      state.isLoading = false;
    },
    // [getLeanList.pending]: (state) => {
    //   state.isLoading = true
    // },
    // [getLeanList.fulfilled]: (state, action) => {
    //   // console.log(action.payload);
    //   state.dataLean = action.payload.data
    //   state.isLoading = false
    // },
    // [getLeanList.rejected]: (state) => {
    //   state.isLoading = false
    // },
    [getLeanById.pending]: (state) => {
      state.isLoading = true;
    },
    [getLeanById.fulfilled]: (state, action) => {
      // console.log(action.payload);
      state.dataByIdLean = action.payload.data;
      state.isLoading = false;
    },
    [getLeanById.rejected]: (state) => {
      state.isLoading = false;
    },
    [getImageLeanList.pending]: (state) => {
      state.isLoading = true;
    },
    [getImageLeanList.fulfilled]: (state, action) => {
      // console.log(action.payload);
      state.dataFeedLean = action.payload.data.content;
      state.isLoading = false;
    },
    [getImageLeanList.rejected]: (state) => {
      state.isLoading = false;
    },
    // [getLeanByRegionalId.pending]: (state) => {
    //   state.isLoading = true
    // },
    // [getLeanByRegionalId.fulfilled]: (state, action) => {
    //   // console.log(action.payload)
    //   state.dataLeanByRegionalId = action.payload.data
    //   state.isLoading = false
    // },
    // [getLeanByRegionalId.rejected]: (state) => {
    //   state.isLoading = false
    // },
    // [postLean.pending]: (state) => {
    //   state.isLoading = true
    // },
    // [postLean.fulfilled]: (state, action) => {
    //   // console.log(action.payload);
    //   state.isOpenForm = false
    //   state.isLoading = false
    // },
    // [postLean.rejected]: (state) => {
    //   state.isLoading = false
    // },
    // [editLean.pending]: (state) => {
    //   state.isLoading = true
    // },
    // [editLean.fulfilled]: (state, action) => {
    //   state.isOpenForm = false
    //   state.isLoading = false
    //   state.dataByIdLean = []
    //   state.idLean = 0
    // },
    // [editLean.rejected]: (state) => {
    //   state.isLoading = false
    // },
    // [deleteLean.pending]: (state) => {
    //   state.isLoading = true
    // },
    // [deleteLean.fulfilled]: (state, action) => {
    //   state.isOpenForm = false
    //   state.isLoading = false
    //   state.dataByIdLean = []
    //   state.idLean = 0
    // },
    // [deleteLean.rejected]: (state) => {
    //   state.isLoading = false
    // },
  },
});

export const { openForm, openImage, openPDF, openDetail } = leanSlice.actions;
export default leanSlice.reducer;
